import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import NotificationImportantRoundedIcon from "@mui/icons-material/NotificationImportantRounded";

export default function Report() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("exportar reporte expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Generar Reporte"
              subtitle="Generar reporte de expedientes"
              icon={<AssessmentRoundedIcon />}
              color="#2563eb"
              to="/legalFile/report"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte basico expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Inventario Expedientes"
              subtitle="Generar inventario de expedientes"
              icon={<DescriptionRoundedIcon />}
              color="#0ea5e9"
              to="/legalFile/report/basic"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte expediente archivo") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reporte por Archivo"
              subtitle="Generar reporte de expedientes desde archivo"
              icon={<TableChartRoundedIcon />}
              color="#8b5cf6"
              to="/legalFile/report/file"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte expediente fallido") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reportes Fallidos"
              subtitle="Generar reportes de expedientes fallidos por la migracion"
              icon={<ReportProblemRoundedIcon />}
              color="#ef4444"
              to="/legalFile/failed/report"
            />
          </Grid>
        )}

        {hasPermission("reporte cedula notificacion") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Operaciones para Cédulas"
              subtitle="Generar reporte de operaciones para cédulas masivas desde archivo"
              icon={<NotificationImportantRoundedIcon />}
              color="#0891b2"
              to="/legalFile/report/operations"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
